import React, { useEffect, useState } from "react";
import api from "@/api/client";
import { Link } from "react-router-dom";
import { TriangleAlert, Check, ArrowUpRight } from "lucide-react";

const inr = (v) => `₹ ${Number(v || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;

export default function Quotations() {
    const [projects, setProjects] = useState([]);
    const [rows, setRows] = useState([]);

    useEffect(() => {
        (async () => {
            const p = await api.get("/projects");
            setProjects(p.data);
            const all = [];
            for (const proj of p.data) {
                try {
                    const q = await api.get(`/projects/${proj.id}/quotations`);
                    q.data.forEach(qq => all.push({ ...qq, project_name: proj.name }));
                } catch { /* */ }
            }
            all.sort((a, b) => (b.created_at || "").localeCompare(a.created_at || ""));
            setRows(all);
        })();
    }, []);

    return (
        <div data-testid="quotations-page" className="space-y-6">
            <div>
                <div className="text-[11px] uppercase tracking-wider text-stone-500 mb-1">Operations</div>
                <h1 className="text-3xl font-heading font-semibold text-stone-900">Quotations</h1>
                <p className="text-sm text-stone-500 mt-1">All vendor quotations you can see. Data-isolated per role.</p>
            </div>
            <div className="bg-white border border-stone-200 rounded-xl overflow-x-auto">
                <table className="w-full text-sm">
                    <thead>
                        <tr className="bg-stone-50 text-[11px] uppercase tracking-wider text-stone-500">
                            <th className="text-left py-3 px-4">Project</th>
                            <th className="text-left py-3 px-4">Vendor</th>
                            <th className="text-right py-3 px-4">Lines</th>
                            <th className="text-right py-3 px-4">Total</th>
                            <th className="text-right py-3 px-4">Mismatches</th>
                            <th className="text-left py-3 px-4">Submitted</th>
                            <th className="text-right py-3 px-4"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map(q => (
                            <tr key={q.id} className="border-t border-stone-100 hover:bg-stone-50">
                                <td className="py-3 px-4 font-medium">{q.project_name}</td>
                                <td className="py-3 px-4 text-stone-700">{q.vendor_name}</td>
                                <td className="py-3 px-4 text-right">{q.lines?.length || 0}</td>
                                <td className="py-3 px-4 text-right font-medium">{inr(q.total)}</td>
                                <td className="py-3 px-4 text-right">
                                    {q.mismatch_count > 0 ? <span className="inline-flex items-center gap-1 text-red-700 text-xs"><TriangleAlert size={12} /> {q.mismatch_count}</span> : <span className="inline-flex items-center gap-1 text-green-700 text-xs"><Check size={12} /> Match</span>}
                                </td>
                                <td className="py-3 px-4 text-xs text-stone-500">{q.created_at?.slice(0, 10)}</td>
                                <td className="py-3 px-4 text-right"><Link to={`/projects/${q.project_id}`} className="text-xs text-amber-700 inline-flex items-center gap-1">Open <ArrowUpRight size={12} /></Link></td>
                            </tr>
                        ))}
                        {rows.length === 0 && <tr><td colSpan={7} className="py-10 text-center text-stone-500 text-sm">No quotations visible.</td></tr>}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
